import { request } from "../axios/request";

export const getAlertRulesService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/alert-rules", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveAlertRuleService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/alert-rules/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/alert-rules", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteAlertRuleService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/alert-rules/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};

export const enableService = (data, id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/alert-rules/" + id, getState(), {
        method: "PATCH",
        data,
      })
    );
  };
};
